import { render, staticRenderFns } from "./vip-nav.vue?vue&type=template&id=7d3ef60e&scoped=true&"
import script from "./vip-nav.vue?vue&type=script&lang=js&"
export * from "./vip-nav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d3ef60e",
  null
  
)

export default component.exports